import React from 'react';
import { Box, Typography, Grid, Divider } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { useForm, SubmitHandler } from 'react-hook-form';
import Input from '../../../../components/Input';
import SearchSelect from '../SearchSelect';
import { useToast } from "@chakra-ui/core";
import Button from 'src/components/Button';
import { AiOutlineClose } from 'react-icons/ai';
import { 
  VehicleProps,
  enTranslateTransmission, 
  enTranslateFuel, 
  enTranslateSteering, 
  enTranslateColor ,
  enBrand
} from 'src/types/IVehicle';
import api from 'src/service/api';

import useStyles from './styles';

interface IModalProps {
  open: boolean;
  handleClose: () => void;
  handlecancel: () => void;
  handleBack: () => void;
}

const FormVehicle = (props: IModalProps) => {
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm();
  const toast = useToast();

  const handleSubmitForm: SubmitHandler<VehicleProps> = async (values) => {
    
    const formatAccessories = values
      .accessories
      .split(',')
      .map((accessory) => ({
        name: accessory.trim()
      }))

    const formatCar = {
      name: values.name,
      brand: values.brand,
      price: Number(values.price),
      fipePrice: Number(values.fipePrice),
      year: Number(values.year),
      yearModel: Number(values.yearModel),
      ports: Number(values.ports),
      km: Number(values.km),
      color: values.color,
      transmission: values.transmission,
      steering: values.steering,
      fuel: values.fuel,
      observations: values.observations,
      accessories: formatAccessories,
      licensePlate: values.licensePlate, 
    }

    try {
      const { data: vehicle } = await api.post('/vehicle', formatCar);
      const data = new FormData();
  
      Array.from(values.image).map((i) => {
        data.append('image', i);
      });
      data.append('thumbnail', values.thumbnail[0]);
      data.append('emailImage', values.emailImage[0]);
      data.append('vehicleId', vehicle.id);
  
      await api.post('/vehicle/image', data);
  
      const dataDocuments = new FormData();
  
      dataDocuments.append('document', values.firstDocument[0]);
      if (values.secondDocument?.[0]) {
        dataDocuments.append('document', values.secondDocument[0]);
      }
      dataDocuments.append('vehicleId', vehicle.id);
  
      await api.post('vehicle/document', dataDocuments)

      props.handlecancel()
      toast({
        position: "top-right",
        title: "Cadatro realizado.",
        description: "Você cadastrou um novo veículo",
        status: "success",
        duration: 4000,
        isClosable: true,
      });

    } catch(err) {
      props.handlecancel();
      toast({
        position: "top-right",
        title: "Algo deu errado.",
        description: "Por favor verifique os dados novamente",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }

};

  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby=""
        classes={{ paper: classes.dialogPaper }}
      >
        <Box component="header" className={classes.header}>
          <Typography className={classes.title}>
            Cadastrar um novo Veículo
          </Typography>
          <button type="button" onClick={props.handlecancel}>
            <AiOutlineClose size={16} />
          </button>
        </Box>
         <form onSubmit={handleSubmit(handleSubmitForm)} style={{ marginTop: '16px'}}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <SearchSelect 
                  name='brand'
                  label='Marca'
                  ref={register({ required: 'A Marca é obritória'})}
                  error={errors}
                  options={Object.entries(enBrand).map(([key, value]) => {
                    return { label: value, value: key };
                  })}
              />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  isFullWidth
                  name='name'
                  label='Modelo'
                  ref={register({ required: 'O modelo do veículo é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <Input 
                  name='yearModel'
                  label='Ano/Modelo'
                  type='number'
                  ref={register({ required: 'Ano/Modelo é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <Input 
                  name='year'
                  label='Ano/Fabricação'
                  type='number'
                  ref={register({ required: 'O Ano de fabricação é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <SearchSelect
                  name='color'
                  label='Cor'
                  ref={register}
                  error={errors}
                  options={Object.entries(enTranslateColor).map(([key, value]) => {
                    return { label: value, value: key };
                  })}
                />
              </Grid>
              <Grid item xs={3}>
                <Input 
                  name='ports'
                  label='N. de Portas'
                  type='number'
                  ref={register}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <Input 
                  name='inspectionCode'
                  label='N. Laudo'
                  type='number'
                  ref={register}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <Input 
                  name='licensePlate'
                  label='Placa'
                  ref={register({ required: 'A placa é obrigatória'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <Input 
                  name='km'
                  label='Km'
                  type='number'
                  ref={register({ required: 'A quilometragem é obrigatória'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={3}>
                <SearchSelect 
                  name='steering'
                  label='Tipo de Direção'
                  ref={register}
                  error={errors}
                  options={Object.entries(enTranslateSteering).map(([key, value]) => {
                    return { label: value, value: key };
                  })}
                />
              </Grid>
              <Grid item xs={6}>
                <SearchSelect 
                  name='fuel'
                  label='Tipo de Combustível'
                  ref={register}
                  error={errors}
                  options={Object.entries(enTranslateFuel).map(([key, value]) => {
                    return { label: value, value: key };
                  })}
                />
              </Grid>
              <Grid item xs={6}>
                <SearchSelect 
                  name='transmission'
                  label='Tipo de Transmissão'
                  ref={register}
                  error={errors}
                  options={Object.entries(enTranslateTransmission).map(([key, value]) => {
                    return { label: value, value: key };
                  })}
                />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  name='price'
                  label='Valor - Oferta'
                  type='number'
                  min="0"
                  ref={register({ required: 'O valor ofertado é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  name='fipePrice'
                  label='Valor - Tabela Fipe'
                  type='number'
                  ref={register({ required: 'O valor da tabela fipe é obrigatório'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  name="accessories"
                  label='Acessórios e Equipamentos'
                  ref={register}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  name='observations'
                  type='textarea'
                  label='Observações'
                  ref={register}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  className={classes.fileUpload}
                  style={{height: '60px'}}
                  name='image'
                  label='Imagens'
                  type='file'
                  multiple
                  ref={register({ required: 'As imagens do veículo são obrigatórias'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  className={classes.fileUpload}
                  style={{height: '60px'}}
                  name='thumbnail'
                  label='Capa do Veículo'
                  type='file'
                  ref={register({ required: 'As imagens do veículo são obrigatórias'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={12}>
                <Input 
                  className={classes.fileUpload}
                  style={{height: '60px'}}
                  name='emailImage'
                  label='Imagem para email'
                  type='file'
                  ref={register({ required: 'As imagens do veículo são obrigatórias'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  name='firstDocument'
                  type='file'
                  label='Vistoria Cautelar'
                  ref={register({ required: 'A vistoria cautelar é obrigatória'})}
                  error={errors}
                />
              </Grid>
              <Grid item xs={6}>
                <Input 
                  name='secondDocument'
                  type='file'
                  label='Vistoria de Constatação (opcional)'
                  ref={register()}
                  error={errors}
                />
              </Grid>
            </Grid>       
            <Divider style={{ width: '100%'}}/>
          <Box className={classes.wrapperButtons}>
            <Button
              fill={false}
              onClick={props.handlecancel}
            >
              Cancelar
            </Button>
            <Button type="submit" className={classes.button}>
              Adicionar Veículo
            </Button>
          </Box>
        </form>
      </Dialog>
    </>
  );
};
export default FormVehicle;